var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import copy from 'clipboard-copy';
import moment from 'moment';
import { stringify } from 'query-string';
import React from 'react';
import { Helmet } from 'react-helmet/es/Helmet';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { v4 } from 'uuid';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { apiCreateSlideClip, apiDeleteSlideClip, } from '../../../actions/AttachmentSlideActions';
import { apiAuthRoleSlide } from '../../../actions/AuthActions';
import { MODAL_TYPE_PDF_VIEW_IMAGE, showModal, } from '../../../actions/ModalActions';
import { showNotification as showNotificationAction } from '../../../actions/NotificationActions';
import { API_GET_ONE_PROFILE_SUCCESS } from '../../../actions/ProfileActions';
import { apiGetOneConsultantSlideSearchPage } from '../../../actions/SearchConsultantActions';
import { hasSlideRole as hasSlideRoleCheck } from '../../../define/consts/role';
import { FORBIDDEN_SLIDE, NOT_FOUND } from '../../../define/response';
import { isNullOrUndefinedOrEmpty } from '../../../helpers/common';
import { propFunc, propShape, propMatch, propHistory, } from '../../../helpers/custom-prop-types';
import Layout from '../../Layout';
import AuthenticationHoc from '../../System/AuthenticationHoc';
import ConsultantSearchSlideLogin from '../Parts/Slide/ConsultantSearchSlideLogin';
import SlideOneShow from './SlideOneShow';
import SlideOneShowSkeleton from './SlideOneShowSkeleton';
class ConsultantSearchSlideOne extends React.Component {
    constructor(props) {
        super(props);
        this.getAttachmentSlide = () => __awaiter(this, void 0, void 0, function* () {
            const { getAttachmentSlidePage, match } = this.props;
            const { id } = (match === null || match === void 0 ? void 0 : match.params) || {};
            const apiId = v4();
            this.apiId = apiId;
            try {
                this.updateState({ loading: true });
                // api実行
                const { payload } = yield getAttachmentSlidePage(id);
                if (apiId !== this.apiId) {
                    return;
                }
                const newMaps = {};
                payload.pages.forEach((page) => {
                    newMaps[page.id] = page.hasFavorite;
                });
                this.updateState((prevState) => ({
                    slideFavoriteMap: Object.assign(Object.assign({}, prevState.slideFavoriteMap), newMaps),
                }));
                this.updateState({ pages: [payload] });
            }
            catch (e) {
                if (e.code === NOT_FOUND) {
                    this.updateState({ notFound: true });
                }
                else if (e.code === FORBIDDEN_SLIDE) {
                    this.updateState({ hasSlideRole: false });
                }
                else {
                    throw e;
                }
            }
            finally {
                this.updateState({ loading: false });
            }
        });
        /**
         * stateの安全な更新
         * @param params
         */
        this.updateState = (params) => {
            if (this.unmount) {
                return;
            }
            this.setState(params);
        };
        /**
         * キーワードの入力変更
         * @param inputKeyword
         */
        this.onChangeKeyword = (inputKeyword) => {
            this.updateState({ inputKeyword });
        };
        /**
         * 検索の実行
         * @param e
         */
        this.onChangeKeywordSubmit = (e) => {
            e.preventDefault();
            const { inputKeyword: keyword } = this.state;
            const { history } = this.props;
            if (isNullOrUndefinedOrEmpty(keyword)) {
                return;
            }
            const newQuery = { keyword, search: 'slide' };
            history.push(`/consultant/search?${stringify(newQuery)}`);
        };
        this.onClickAddSlideClip = (id) => {
            const { createSlideClip } = this.props;
            const { slideFavoriteMap } = this.state;
            this.setState({
                slideFavoriteMap: Object.assign(Object.assign({}, slideFavoriteMap), { [id]: true }),
            });
            createSlideClip(id);
        };
        this.onClickDeleteSlideClip = (id) => {
            const { deleteSlideClip } = this.props;
            const { slideFavoriteMap } = this.state;
            this.setState({
                slideFavoriteMap: Object.assign(Object.assign({}, slideFavoriteMap), { [id]: false }),
            });
            deleteSlideClip(id);
        };
        this.onClickCopy = (e) => __awaiter(this, void 0, void 0, function* () {
            const { value } = e.currentTarget;
            const { showNotification } = this.props;
            const url = [
                `${window.location.protocol}//${window.location.host}`,
                'consultant',
                'slide',
                'page',
                value,
            ].join('/');
            yield Promise.all([copy(url), showNotification('コピーしました。')]);
        });
        this.onClickSlideShow = (e) => {
            const { showPdfModal } = this.props;
            const { pages } = this.state;
            const id = parseInt(e.currentTarget.value, 10);
            const model = pages.find((findModel) => findModel.id === id);
            if (model) {
                const initialSlide = model.pages.findIndex((pageModel) => pageModel.id === model.id);
                showPdfModal(model.pages, Math.max(initialSlide, 0));
            }
        };
        this.apiId = null;
        this.unmount = false;
        const { profile } = props;
        this.state = {
            hasSlideRole: hasSlideRoleCheck(profile, moment()),
            inputKeyword: '',
            loading: true,
            notFound: false,
            pages: [],
            slideFavoriteMap: {},
        };
    }
    componentDidMount() {
        this.getAttachmentSlide();
    }
    shouldComponentUpdate(nextProps) {
        const { profile } = this.props;
        if (profile !== nextProps.profile) {
            const now = moment();
            const currentHasSlideRole = hasSlideRoleCheck(profile, now);
            const newHasSlideRole = hasSlideRoleCheck(nextProps.profile, now);
            if (currentHasSlideRole === false && newHasSlideRole === true) {
                this.setState({ hasSlideRole: newHasSlideRole });
                this.getAttachmentSlide().then();
                return false;
            }
        }
        return true;
    }
    componentWillUnmount() {
        this.unmount = true;
    }
    render() {
        const { login, updateProfile } = this.props;
        const { hasSlideRole, loading, notFound, pages, slideFavoriteMap } = this.state;
        if (notFound) {
            return _jsx(CustomRedirect, { to: '/mypage' });
        }
        return (_jsxs(Layout, Object.assign({ headerType: 'search', mainClassName: 'l-main layout-consultant-search', onChangeKeyword: this.onChangeKeyword, onSubmitSearch: this.onChangeKeywordSubmit }, { children: [_jsxs("div", Object.assign({ className: 'search_header_wrapper' }, { children: [_jsx("div", { className: 'search_header_block' }), _jsx("hr", { className: 'search_header_divider' })] })), loading && pages.length === 0 ? (_jsx(SlideOneShowSkeleton, {})) : (_jsxs(_Fragment, { children: [_jsx(ConsultantSearchSlideLogin, { hasSlideRole: hasSlideRole, isShowLoginModal: !hasSlideRole, onSubmitLogin: login, updateProfile: updateProfile }), hasSlideRole && (_jsxs(_Fragment, { children: [_jsx(Helmet, { children: _jsx("title", { children: `コンサル検索 スライド ${pages[0].title || ''}｜PROFFIT` }) }), _jsx(SlideOneShow, { createSlideClip: this.onClickAddSlideClip, deleteSlideClip: this.onClickDeleteSlideClip, onClickCopy: this.onClickCopy, onClickShow: this.onClickSlideShow, pageNo: 1, pages: pages, slideFavoriteMap: slideFavoriteMap })] }))] }))] })));
    }
}
ConsultantSearchSlideOne.propTypes = {
    createSlideClip: propFunc().isRequired,
    deleteSlideClip: propFunc().isRequired,
    getAttachmentSlidePage: propFunc().isRequired,
    history: propHistory(),
    login: propFunc().isRequired,
    match: propMatch(),
    profile: propShape(),
    showNotification: propFunc().isRequired,
    showPdfModal: propFunc().isRequired,
    updateProfile: propFunc().isRequired,
};
ConsultantSearchSlideOne.defaultProps = {
    profile: {},
};
const mapStateToProps = ({ profile }) => ({ profile });
const mapDispatchToProps = (dispatch) => ({
    createSlideClip: (slideId, pageId) => new Promise((resolve, reject) => {
        dispatch(apiCreateSlideClip(pageId, { reject, resolve }));
    }),
    deleteSlideClip: (slideId, pageId) => new Promise((resolve, reject) => {
        dispatch(apiDeleteSlideClip(pageId, { reject, resolve }));
    }),
    getAttachmentSlidePage: (slideId) => new Promise((resolve, reject) => {
        dispatch(apiGetOneConsultantSlideSearchPage(slideId, { reject, resolve }));
    }),
    login: (values) => new Promise((resolve, reject) => {
        dispatch(apiAuthRoleSlide(values, { reject, resolve }));
    }),
    showNotification: (message) => dispatch(showNotificationAction(message)),
    showPdfModal: (images, initialSlide) => dispatch(showModal(MODAL_TYPE_PDF_VIEW_IMAGE, null, {
        images,
        initialSlide,
        pdfProp: { isObject: true, key: 'image' },
    })),
    updateProfile: (profile) => dispatch({ payload: profile, type: API_GET_ONE_PROFILE_SUCCESS }),
});
const enhance = compose(AuthenticationHoc({ isAdmin: true }), connect(mapStateToProps, mapDispatchToProps));
export default enhance(ConsultantSearchSlideOne);
